import Box from '@mui/material/Box';

const Subtitle = (props: { children: JSX.Element | string | (JSX.Element | string)[] }) =>
{
  const styles = {
    fontFamily: 'Archivo, sans-serif',
    fontSize: 24,
    marginTop: 40 };

  return <Box><h1 style={styles}>{props.children}</h1></Box>;
};

export default Subtitle;
